__turbopack_context__.v({
  "avatar": "UserProfile-module__MaYLMG__avatar",
  "bioContent": "UserProfile-module__MaYLMG__bioContent",
  "createIssueButton": "UserProfile-module__MaYLMG__createIssueButton",
  "dimmed": "UserProfile-module__MaYLMG__dimmed",
  "editIcon": "UserProfile-module__MaYLMG__editIcon",
  "fullName": "UserProfile-module__MaYLMG__fullName",
  "fullWidthAnchor": "UserProfile-module__MaYLMG__fullWidthAnchor",
  "issueSubtitle": "UserProfile-module__MaYLMG__issueSubtitle",
  "issueTitle": "UserProfile-module__MaYLMG__issueTitle",
  "profileCard": "UserProfile-module__MaYLMG__profileCard",
  "profileContainer": "UserProfile-module__MaYLMG__profileContainer",
  "publicTitle": "UserProfile-module__MaYLMG__publicTitle",
  "shortName": "UserProfile-module__MaYLMG__shortName",
  "swayScore": "UserProfile-module__MaYLMG__swayScore",
  "tab": "UserProfile-module__MaYLMG__tab",
  "tabs": "UserProfile-module__MaYLMG__tabs",
  "tabsList": "UserProfile-module__MaYLMG__tabsList",
});
